export enum AIAssistantQuestionTypes {
  ASK = 'ASK',
  ASK_DOC = 'ASK_DOC',
}

export type AIAssistantQuestionType =
  (typeof AIAssistantQuestionTypes)[keyof typeof AIAssistantQuestionTypes]

export type AIAssistantSelectedDocument = {
  id: number
  type: 'file'
  name: string
  basename?: string
  numbering?: string | null
}

export type AICredits = {
  remaining: number
  renewalDate?: string
  total: number
}

export type AIAssistantConversation = {
  room: {
    mnemo: string
    name: string
  }
  id: string
  type: AIAssistantQuestionType,
  title: string | null
  createdAt: string
  updatedAt: string | null
  messages: Array<AIAssistantMessage>
}

export type AIAssistantConversationListData = {
  yesterday: AIAssistantConversation[]
  today: AIAssistantConversation[]
  lastSevenDays: AIAssistantConversation[]
  lastThirtyDays: AIAssistantConversation[]
  lastNinetyDays: AIAssistantConversation[]
}

export type AIAssistantConversationMessage = {
  conversationId: string
  createdAt: string
  id: string
  prompt: string
  response: string
  sources?: Array<{title: string, link: string}>
  updatedAt: string | null
  errorCode?: string
  errorMessage?: string
  isRetryable?: boolean
}

export type AIAssistantMessage = {
  id: string
  role: 'user' | 'assistant' | 'system'
  content: string
  timestamp: string
}
